import { format } from 'date-fns'
import { de } from 'date-fns/locale'

export function readableDate(date) {
    return format(new Date(date), "d.M.y H:mm", {
        locale: de
    })
}